import React from "react";
import doc from "../../assets/img/doctor/pavithara-h.jpeg";
import { useLocation, Link } from "react-router-dom";
import CustomTitle from "../../CustomTitle";

export default function Pavithra() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  const helmetDescriptions = {
    titleName: "Ms. Pavithra H - Best Embryologist in Ramanagara/Bangalore",
    Description:
      "Looking for the best embryologist in Ramanagara or Bangalore? Consult Ms. Pavithra H., a top specialist offering expert fertility care and personalized treatments.",
  };

  return (
    <div id="each-doctor">
      <CustomTitle customValue={helmetDescriptions} />
      {/* <div className="py-md-5" style={{ backgroundImage: "url(" + blogHeader + ")", backgroundPosition: 'center', backgroundSize: 'cover', height: '400px' }}>
        <div className="banner-header text-center py-5">
            <h2 style={{ color: '#fff', position: "relative", top: "100px" }}>Dr. DIVYASREE D</h2>
        </div>
    </div> */}
      <br />
      {/* <h6 className="offset-1 my-4 "  style={{ textAlign: "left", color: "black" }}>HOME &gt; MEDIA &gt; Blog</h6> */}
      <nav aria-label="breadcrumb" id="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>

          <li className="breadcrumb-item active" aria-current="page">
            Doctor
          </li>
        </ol>
      </nav>
      {/* -------------------------doctor detail--------------- */}

      <div className="container mt-4">
        <div className="row">
          <div className="col-md-5">
            <div className="card" style={{ maxWidth: "30rem" }}>
              <img src={doc} className="card-img-top" alt="Dr. Divyashree D" />
            </div>
            <br />
            <br />
            <br />
            <h3>More Info</h3>
            <br />
            <p>DMLT</p>
            <br />
            <p>
              Department : <span>Infertility And Ivf</span>
            </p>
            <br />
            {/* <p>Consultations : 15 Minutes per Consultation</p>
            <br /> */}
            <p>Location : Ramanagara</p>
            <br />

            <span className="badge bg-primary p-2">
              Available on Prior Appointment
            </span>
            <br />
            <p> - Toll-free number @ 1800-425-4500</p>
            <br />
          </div>

          <div className="col-md-7">
            <h1 className="text-blue">MS . PAVITHRA H</h1>
            <p>
              <strong>JUNIOR EMBRYOLOGIST </strong>
            </p>
            <br />

            <br />
            <h3>Work Experience:</h3>
            <li>
              Garbhagudi IVF Center, Kalyan Nagar-Lab Technician & Andrology
              Technician
            </li>
            <li>Agarwal Eye Hospital, Coles Road-Lab Technician</li>
            <li>Adhya Hospital-Lab Technician</li>
            <li>Jayashree Hospital, Tumkur-Lab Technician</li>
          </div>
        </div>
      </div>
    </div>
  );
}
